import { render, staticRenderFns } from "./AddAdsAccount.vue?vue&type=template&id=44ee4064&scoped=true&"
import script from "./AddAdsAccount.vue?vue&type=script&lang=js&"
export * from "./AddAdsAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddAdsAccount.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddAdsAccount.vue?vue&type=style&index=1&id=44ee4064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ee4064",
  null
  
)

export default component.exports